import { StorefrontFeedItem } from '@/ux/pages/StoreFrontPage/Social/StoreFrontSocial';
import { StoreEvent, StoreFront } from '@/ux/pages/StoreFrontPage/StoreFront';

export type StorefrontType = {
  products: StoreEvent[];
  feeds: StorefrontFeedItem[];
  store: StoreFront | null;
  highlights: any[];
  socialScrollDistance: number;
  userRole: STORE_USER_ROLE;
};

export enum STORE_USER_ROLE {
  OWNER = 'OWNER',
  EMPLOYEE = 'EMPLOYEE',
  GUEST = 'GUEST',
}
